import { Sparkles } from 'lucide-react';
import { ImageWithFallback } from './figma/ImageWithFallback';
import { RecipeTimeChips } from './RecipeTimeChips';

export function RecipeCard({ recipe, onClick }) {
  const tags = Array.isArray(recipe.tags) ? recipe.tags : [];
  return (
    <button
      onClick={onClick}
      className="w-full bg-white rounded-2xl shadow-sm overflow-hidden hover:shadow-md transition-shadow text-left"
    >
      {/* Hero Image */}
      <div className="w-full aspect-[4/3] overflow-hidden bg-gray-100 relative">
        {recipe.shared ? (
          <div className="absolute top-3 right-3 bg-white/95 backdrop-blur-sm px-2.5 py-1 rounded-full flex items-center gap-1.5 shadow-sm z-10">
            <Sparkles className="w-3.5 h-3.5 text-[#8B9A7A] stroke-[#8B9A7A]" />
            <span className="text-xs text-[#6B7A54] font-medium">Starter Recipe</span>
          </div>
        ) : null}
        <ImageWithFallback
          src={recipe.imageThumb || recipe.image}
          fallbackSrc={recipe.image}
          alt={recipe.name}
          loading="lazy"
          decoding="async"
          fetchPriority="low"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Content */}
      <div className="p-4">
        {/* Recipe Name */}
        <h3 className="text-lg mb-3">{recipe.name}</h3>

        {/* Time Info */}
        <div className="flex items-center gap-4 mb-3 text-sm text-[#757575]">
          <RecipeTimeChips recipe={recipe} itemClassName="flex items-center gap-1" />
        </div>

        {/* Tags */}
        <div className="flex flex-wrap gap-2">
          {tags.map((tag) => (
            <span
              key={tag}
              className="px-3 py-1 bg-[#E8F0ED] text-[#6B8A78] rounded-full text-xs"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </button>
  );
}
